import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';

export const StyledAccordion = styled(Accordion, {
  shouldForwardProp: prop => prop !== 'hasError'
})(({ theme, hasError }) => ({
  ...(hasError && {
    border: `2px solid ${theme.palette.error.main}`
  })
}));

export const StyledAccordionSummary = styled(AccordionSummary)({
  '& > div': {
    alignItems: 'center',
    justifyContent: 'space-between'
  }
});

export const StyledAccordionDetails = styled(AccordionDetails)({
  flexDirection: 'column',
  alignItems: 'center'
});

export const TitleCnt = styled('div')({
  display: 'flex'
});

export const StyledTitle = styled(Typography)(({ theme }) => ({
  marginLeft: theme.spacing(1)
}));

export const StyledAvatar = styled(Avatar)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  width: 24,
  height: 24,
  fontSize: 'small'
}));

export const StyledField = styled('div')(({ theme }) => ({
  margin: theme.spacing(1.5, 0),
  width: '100%'
}));

export const FieldsGroupCnt = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  margin: theme.spacing(2, 0),
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column'
  },
  [theme.breakpoints.up('sm')]: {
    alignItems: 'center'
  }
}));

export const CheckBoxCnt = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    marginTop: theme.spacing(2)
  }
}));
